import { STORAGE_KEYS } from '../constants';

export function saveToken(token: string, expiresIn: number): void {
  localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, token);
  const expiryTime = Date.now() + expiresIn * 1000;
  localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN_EXPIRY, expiryTime.toString());
}

export function getToken(): string | null {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  const expiry = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN_EXPIRY);
  
  if (!token || !expiry) {
    return null;
  }
  
  // Check if token is expired
  const expiryTime = parseInt(expiry, 10);
  const now = Date.now();
  if (now > expiryTime) {
    clearToken();
    return null;
  }
  
  return token;
}

export function clearToken(): void {
  localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN_EXPIRY);
}

